import custom from 'shared/styles/custom.styles'

const styles = () => {
    return { text: custom.stepText }
}

export default styles
